import { useQuery } from "@tanstack/react-query";
import api from "../../../api";


export const useTimelineMediaTypes = () => {
    const { data: timelineMediaTypes, error: timelineMediaTypesError } = useQuery({
        queryKey: ['timelineMediaTypes'],
        queryFn: () => api.mediaTypes.getMediaTypes(),
        select: (data) => data?.data?.data
    });

    return { timelineMediaTypes, timelineMediaTypesError };
}